import React from 'react';
import {
  composeValidators,
  maxCharacters,
  required,
  valueEquals,
} from '../../../utils/formFieldValidators';
import { TextField, RadiosField } from '../../01_atoms/FormElements';
import PopupLink from '../PopupLink';
import programmeStyles from '../../03_organisms/BodyBlocks/BBProgramme/index.module.scss';

// TODO: Move to donation form settings in https://www.pivotaltracker.com/story/show/165503378
const LegalCopy = () => (
  <>
    <h2>Legal text</h2>
    <p>
      Concern
      <br />
      52-55 Lower Camden Street
      <br />
      Dublin 2<br />
      ++ 353 1 417 7777
      <br />
    </p>
    <p>Creditors Identifier No. IE19ZZZ303494</p>
    <p>
      By signing this mandate form, you authorise (A) Concern Worldwide to send instructions to your
      bank to debit your account and (B) your bank to debit your account in accordance with the
      instruction from Concern Worldwide.
    </p>
    <p>
      As part of your rights, you are entitled to a refund from your bank under the terms and
      conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting
      from the date on which you account was debited. Your rights are explained in a statement that
      you can obtain from your bank.
    </p>
  </>
);

const DonationDirectDebitSEPA = () => (
  <>
    <TextField
      name="payment_options.account_name"
      label="Name"
      validate={required('Please enter your account name in order to proceed')}
      isRequired
      placeholder="Jane Bloggs"
    />
    {/* TODO: add validators and parsers for BIC and IBAN. */}
    <div className="form-field-with-description bic-field">
      <TextField
        name="payment_options.swift"
        label="BIC number"
        validate={composeValidators(
          required(
            'Please enter BIC number. It begins with 6 letters and is 8 or 11 characters long',
          ),
          maxCharacters(11, 'Your BIC number should be 8 or 11 characters long'),
        )}
        isRequired
        info="BIC begins with 6 letters and is 8 or 11 characters long"
        placeholder="ABCDEF0A"
      />
    </div>

    <div className="form-field-with-description iban-field">
      <TextField
        name="payment_options.iban"
        label="IBAN number"
        validate={required(
          'Please enter your IBAN number. It begins with IE and is 22 characters long',
        )}
        isRequired
        info={
          'IBAN begins with IE and is 22 characters long. <a href="https://www.iban.com/calculate-iban" target="_blank" rel="noopener noreferrer">Find my IBAN</a>'
        }
        placeholder="IE 00ABCD00000000000000"
      />
    </div>

    <div className="radio-buttons-inline radio-buttons-direct-debit-sepa">
      <RadiosField
        name="payment_options.accept_direct_debits"
        label="Can this bank account accept Direct Debits?"
        options={[
          { value: '1', label: 'Yes' },
          { value: '0', label: 'No' },
        ]}
        validate={composeValidators(
          required(),
          valueEquals(
            '1',
            'In order to make a direct debit donation the account should accept direct debits. For help: phone our Donor Care Team on +353 1 417 7777.',
          ),
        )}
        isRequired
      />

      <RadiosField
        name="payment_options.one_signatory"
        label="Is there more than one signatory required to sign on your account?"
        options={[
          { value: '0', label: 'Yes' },
          { value: '1', label: 'No' },
        ]}
        validate={composeValidators(
          required(),
          valueEquals(
            '1',
            'In order to make a direct debit donation only one signatory must be required on your account. For help: phone our Donor Care Team on +353 1 417 7777.',
          ),
        )}
        isRequired
      />

      <div className="text-with-popup">
        <span>This is a recurring payment. </span>
        <span>
          <PopupLink
            className={programmeStyles['popup-programme']}
            linkText="Legal text for monthly payments"
          >
            <LegalCopy />
          </PopupLink>
        </span>
        .
      </div>
    </div>

    <div className="hr" />
  </>
);

export default DonationDirectDebitSEPA;
